import { EventStatus } from '../../../constants/EventStatus';
import { Filter } from '../../../constants/Filters';
import { BasicModel } from '../basic.model.dto';
export class LeadsFilterLocalStorageDto {
  userSelectionComponentSelectedItems: BasicModel[];
  brandSelectionComponentSelectedItems: BasicModel[];
  channelSelectionComponentSelectedItems: BasicModel[];
  dealerSelectionComponentSelectedItems: BasicModel[];
  typesSelectionComponentSelectedItems: BasicModel[];
  originSelectedItem: string;
  createdAtFrom: Date;
  createdAtTo: Date;
  updatedAtFrom: Date;
  updatedAtTo: Date;
  visitDateFrom: Date;
  visitDateTo: Date;
  visitStatus: string;
  reminderDateFrom: Date;
  reminderDateTo: Date;
  filterArchived: boolean;
  filterClosed: boolean;
  filterNewLead: boolean;
  filterOnTrackHot: boolean;
  filterOnTrackWarm: boolean;
  filterOnTrackCold: boolean;
  filterTransfered: boolean;
  filterReminders: boolean;
  filterTotalVisits: boolean;
  filterVisits: boolean;
  dateModel: string;
  rangeSelected: string;
  dateUpdateModel: string;
  rangeUpdatedSelected: string;
  archivedComment: string;
  archivedNotContacted: boolean;
  archivedNotInterested: boolean;
  archivedOther: boolean;
  archivedByPrice: boolean;
  archivedByAppraisal: boolean;
  archivedByFinancing: boolean;
  archivedImmature: boolean;
  archivedSameBrand: boolean;
  archivedAnotherBrand: boolean;
  archivedSameBrandDealership: boolean;
  archivedAnotherBrandDealership: boolean;
  descriptionModel: string;
  leadContact: string;
  leadContactType: string;
  leadContactPhoneObject: any;
  closedAtFrom: Date;
  closedAtTo: Date;
  closedComment: string;
  contactStatus: string;
  filterOnCall: boolean;
  filterOnPrequalification: boolean;
  filterTransfereds: boolean;
  archivedAtFrom: Date;
  archivedAtTo: Date;
  postalCode: string;
  postalCodeType: string;
  scoring: {
    scoringFrom: number;
    scoringTo: number;
    scoringNull: boolean;
  };
  assignmentRuleName: string;
  positiveRulesSelectionComponentSelectedItems: BasicModel[];
  isActiveSelectionComponentSelectedItems: BasicModel[];

  static copy(source: string, target: string): void {
    localStorage.setItem(target, localStorage.getItem(source));
  }

  constructor() {
    this.setFilterFromDropdowns({});
  }

  generateFilter(filter: any, dropdowns: any, filterStatus?: any, filterUpdateCreateRanges?: any, archivedFilter?: any, phoneObject?: any): LeadsFilterLocalStorageDto {
    this.originSelectedItem = filter.origin;
    this.visitDateFrom = filter.visitDateFrom;
    this.visitDateTo = filter.visitDateTo;
    this.visitStatus = filter.visitStatus;
    this.reminderDateFrom = filter.reminderDateFrom;
    this.reminderDateTo = filter.reminderDateTo;
    this.assignmentRuleName = filter.assignmentRuleName;
    this.positiveRulesSelectionComponentSelectedItems = filter.positiveRule;
    this.isActiveSelectionComponentSelectedItems = filter.isActive;

    this.scoring = filter.scoring;
    this.setPostalCodeFilter(filter);
    this.setInfoFilter(filter, phoneObject, dropdowns);

    if (filterStatus) {
      this.setFilterStatus(filterStatus);
    }

    if (filterUpdateCreateRanges) {
      this.setDateRanges(filterUpdateCreateRanges, filter);
    }

    this.setCloseFilter(filter);

    if (archivedFilter) {
      this.setArchivedFilter(archivedFilter, filter);
    }

    return this;
  }

  setInfoFilter(filter: any, phoneObject: any, dropdowns) {
    this.descriptionModel = filter.descriptionModel;
    this.leadContact = filter.leadContact;
    this.leadContactType = filter.leadContactType;
    this.leadContactPhoneObject = phoneObject;

    this.setFilterFromDropdowns(dropdowns);
  }

  setPostalCodeFilter(filter: any) {
    this.postalCodeType = filter.postalCodeType;
    this.postalCode = filter.postalCode;
  }

  setCloseFilter(filter: any) {
    this.closedAtFrom = filter.closedAtFrom;
    this.closedAtTo = filter.closedAtTo;
    this.closedComment = filter.closedComment;
  }
  setArchivedFilter(filterArchived: any, filter: any) {
    this.filterArchived = filterArchived.filterArchived;
    this.archivedComment = filter.archivedComment;
    this.archivedAtFrom = filter.archivedAtFrom;
    this.archivedAtTo = filter.archivedAtTo;
    this.archivedNotContacted = filterArchived.archivedNotContacted;
    this.archivedNotInterested = filterArchived.archivedNotInterested;
    this.archivedOther = filterArchived.archivedOther;
    this.archivedByPrice = filterArchived.archivedByPrice;
    this.archivedByAppraisal = filterArchived.archivedByAppraisal;
    this.archivedByFinancing = filterArchived.archivedByFinancing;
    this.archivedImmature = filterArchived.archivedImmature;
    this.archivedSameBrand = filterArchived.archivedSameBrand;
    this.archivedAnotherBrand = filterArchived.archivedAnotherBrand;
    this.archivedSameBrandDealership = filterArchived.archivedSameBrandDealership;
    this.archivedAnotherBrandDealership = filterArchived.archivedAnotherBrandDealership;
  }

  setDateRanges(filterUpdateCreateRanges: any, filter: any) {
    this.dateModel = filterUpdateCreateRanges.dateModel;
    this.rangeSelected = filterUpdateCreateRanges.rangeSelected;
    this.dateUpdateModel = filterUpdateCreateRanges.dateUpdateModel;
    this.rangeUpdatedSelected = filterUpdateCreateRanges.rangeUpdatedSelected;
    this.createdAtFrom = filter.createdAtFrom;
    this.createdAtTo = filter.createdAtTo;
    this.updatedAtFrom = filter.updatedAtFrom;
    this.updatedAtTo = filter.updatedAtTo;
  }

  setFilterStatus(filterStatus: any): LeadsFilterLocalStorageDto {
    this.filterClosed = filterStatus.filterClosed;
    this.filterNewLead = filterStatus.filterNewLead;
    this.filterOnTrackHot = filterStatus.filterOnTrackHot;
    this.filterOnTrackWarm = filterStatus.filterOnTrackWarm;
    this.filterOnTrackCold = filterStatus.filterOnTrackCold;
    this.filterTransfered = filterStatus.filterTransfereds;
    this.filterReminders = filterStatus.filterReminders;
    this.filterVisits = filterStatus.filterVisits;
    this.contactStatus = filterStatus.contactStatus;
    this.filterOnCall = filterStatus.filterOnCall;
    this.filterOnPrequalification = filterStatus.filterOnPrequalification;
    this.filterTransfereds = filterStatus.filterTransfereds;

    return this;
  }

  setClosedsFilter(): LeadsFilterLocalStorageDto {
    this.filterOnTrackHot = false;
    this.filterOnTrackWarm = false;
    this.filterOnTrackCold = false;
    this.filterClosed = true;
    this.filterOnCall = false;
    this.filterOnPrequalification = false;
    this.filterArchived = false;
    this.archivedComment = '';
    this.archivedAtFrom = null;
    this.archivedAtTo = null;
    this.archivedNotContacted = false;
    this.archivedNotInterested = false;
    this.archivedOther = false;
    this.archivedByPrice = false;
    this.archivedByAppraisal = false;
    this.archivedByFinancing = false;
    this.archivedImmature = false;
    this.archivedSameBrand = false;
    this.archivedAnotherBrand = false;
    this.archivedSameBrandDealership = false;
    this.archivedAnotherBrandDealership = false;
    this.contactStatus = '';
    this.scoring = {
      scoringFrom: null,
      scoringTo: null,
      scoringNull: false,
    };
    return this;
  }

  setContactedsFilter(): LeadsFilterLocalStorageDto {
    this.contactStatus = 'contacteds';
    return this;
  }

  setTotalVisitsFilter(): LeadsFilterLocalStorageDto {
    this.filterVisits = true;

    return this;
  }

  setVisitedsFilter(): LeadsFilterLocalStorageDto {
    this.visitStatus = EventStatus.DONE;

    return this;
  }

  save(filterName: string = Filter.LEADS) {
    localStorage.setItem(filterName, JSON.stringify(this));
  }

  setFilterFromDropdowns(dropdowns: any, update?: boolean): LeadsFilterLocalStorageDto {

    this.userSelectionComponentSelectedItems = this.getSelectedItems(dropdowns.users);
    this.brandSelectionComponentSelectedItems = this.getSelectedItems(dropdowns.brands);
    this.channelSelectionComponentSelectedItems = this.getSelectedItems(dropdowns.channels);
    this.dealerSelectionComponentSelectedItems = this.getSelectedItems(dropdowns.dealers);
    this.typesSelectionComponentSelectedItems = this.getSelectedItems(dropdowns.types);
    this.positiveRulesSelectionComponentSelectedItems = this.getSelectedItems(dropdowns.positiveRules);
    this.isActiveSelectionComponentSelectedItems = this.getSelectedItems(dropdowns.activeRules);

    return this;
  }

  updateDropdowns(dropdowns: any, itemSelected: any): LeadsFilterLocalStorageDto {
    if (!itemSelected) {
      return this;
    }
    for (const key in dropdowns) {
      if (Object.prototype.hasOwnProperty.call(dropdowns, key)) {
        this[this.getSelectComponent(key)] = this.getSelectedItems(dropdowns[key]);
      }
    }
    return this;
  }

  generateFromJSON(data: any): LeadsFilterLocalStorageDto {
    Object.assign(this, data);

    return this;
  }
  private getSelectedItems(dropdown: any): BasicModel[] {

    if (dropdown) {
      return dropdown.selectedItems;
    }

    return Array<BasicModel>();
  }

  private getSelectComponent(key: string): string {
    const mapDropdowns = {
      users: 'userSelectionComponentSelectedItems',
      brands: 'brandSelectionComponentSelectedItems',
      channels: 'channelSelectionComponentSelectedItems',
      dealers: 'dealerSelectionComponentSelectedItems',
      types: 'typesSelectionComponentSelectedItems',
      positiveRules: 'positiveRulesSelectionComponentSelectedItems',
      isActive: 'isActiveSelectionComponentSelectedItems',
    };

    return mapDropdowns[key];
  }

}
